module.exports = __webpack_public_path__ + "img/medgate_logo_white.ae584577.png";